import { color } from '../styles/tokens';

// The V-Tech gear/cog mark used in the header, footer and loading curtain.
export const BrandMark = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 200 200" aria-hidden="true">
    <path
      fillRule="evenodd"
      fill={color.accent}
      d="M 100.0 8.0 L 119.7 26.6 L 146.0 20.3 L 153.7 46.3 L 179.7 54.0 L 173.4 80.3 L 192.0 100.0 L 173.4 119.7 L 179.7 146.0 L 153.7 153.7 L 146.0 179.7 L 119.7 173.4 L 100.0 192.0 L 80.3 173.4 L 54.0 179.7 L 46.3 153.7 L 20.3 146.0 L 26.6 119.7 L 8.0 100.0 L 26.6 80.3 L 20.3 54.0 L 46.3 46.3 L 54.0 20.3 L 80.3 26.6 Z M 100 70 A 30 30 0 1 0 100 130 A 30 30 0 1 0 100 70 Z"
    />
    <circle cx="100" cy="100" r="22" fill={color.text} />
  </svg>
);

// The stacked "V-TECH / INDUSTRIES" wordmark.
export const Wordmark = () => (
  <span style={{ display: 'flex', flexDirection: 'column', lineHeight: 1, textAlign: 'left' }}>
    <span style={{ font: `700 20px/1 ${'Space Grotesk'}, sans-serif`, color: color.text, letterSpacing: '.02em' }}>
      V-TECH
    </span>
    <span style={{ font: `500 8px/1 'JetBrains Mono', monospace`, letterSpacing: '.42em', color: color.accent, marginTop: 5 }}>
      INDUSTRIES
    </span>
  </span>
);
